import React from 'react';
import {
  Icon,
  Tooltip
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';


interface IInfoTooltip {
  title: string,
  classNames?: string,
  style?: React.CSSProperties
}

const useStyles = makeStyles(() => ({
  tooltip: {
    color: '#001239',
    fontSize: '14px',
    marginLeft: '5px'
  }
}));

const InfoTooltip = ({title, classNames, style}: IInfoTooltip) => {
  const classes = useStyles();

  return (
    <Tooltip title={title}>
      <Icon className={`${classes.tooltip} ${classNames}`} style={style}>info_outline</Icon>
    </Tooltip>
  );
};

export default InfoTooltip;
